<template>
    <div class="customerPage">
        <headerNotice routerName="用户列表"></headerNotice>
        <!-- 筛选条 -->
        <div class="searchBox">
            <h2 class="searchTitle">
                <i></i>
                <span>筛选查询</span>
            </h2>
            <el-form :inline="true" :model="searchForm" class="demo-form-inline searchForm">
                <el-form-item label="客户名称">
                    <el-input v-model="searchForm.customerName" clearable placeholder="客户名称/手机号"></el-input>
                </el-form-item>
                <!-- <el-form-item label="地区名称">
                    <el-input v-model="searchForm.areaName" clearable placeholder="地区名称" style='width: 180px'></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="审核状态">
                    <el-select v-model="searchForm.audit" placeholder="全部" style='width: 180px'>
                        <el-option label="全部" value></el-option>
                        <el-option label="通过" value="1"></el-option>
                        <el-option label="未通过" value="0"></el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="所属业务员">
                    <el-input v-model="searchForm.salesmanName" clearable placeholder="所属业务员" style='width: 180px'></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="onSearch">查询结果</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="dialogSearchForm2Visible=true">高级检索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 搜索结果列表 -->
        <div class="searchList" v-loading="loading">
            <div class="searchListHead">
                <h2 class="searchListTitle">
                    <i></i>
                    <span>数据列表</span>
                </h2>
                <div class="searchListCtl">
                    <!-- <el-button @click="onCoupon">发放优惠券</el-button> -->
                    <!-- <el-button @click="onExamineForm">客户审核</el-button>
                    <el-button @click="onCustomerSalesmanForm">分配业务员</el-button> -->
                    <!-- <el-button>导出数据</el-button> -->
                    <!-- 已整合到翻页 -->
                    <!-- <el-select v-model="searchListCtlForm.num" placeholder="显示条数">
                        <el-option label="默认显示数" value></el-option>
                        <el-option label="5条" value="1"></el-option>
                        <el-option label="10条" value="2"></el-option>
                    </el-select>-->
                    <!-- 暂无该功能 -->
                    <!-- <el-select v-model="searchListCtlForm.arrange" placeholder="排列方式">
                        <el-option label="默认排列方式" value></el-option>
                        <el-option label="按客户名" value="1"></el-option>
                        <el-option label="按业务员" value="2"></el-option>
                    </el-select>-->
                </div>
            </div>
            <div class="searchListContent">
                <el-table
                    ref="searchListTable"
                    :data="searchListTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="customerSlelectionChange"
                    border
                >
                    <el-table-column align='center' type="selection" width="55"></el-table-column>
                    <el-table-column align='center' prop="userName" label="微信名称" width="220">
                        <template slot-scope="scope">
                            <span
                                class="detialSpan"
                                @click="onCustomerDetail(scope.row)"
                            >{{scope.row.userName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align='center' prop="HeadImg" width="80" label="微信头像">
                        <template slot-scope="scope">
                            <img :src="scope.row.headImg" alt width="50" height="50">
                        </template>
                    </el-table-column>
                    <!-- <el-table-column align='center' prop="areaName" label="所在地区" width="160">
                        <template slot-scope="scope">
                            <span>{{scope.row.provinceName}}{{scope.row.cityName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align='center' prop="linkman" label="联系人"></el-table-column>
                    <el-table-column align='center' prop="phone" label="联系电话"></el-table-column> -->
                    <el-table-column align='center' prop="integral" label="积分"></el-table-column> -->
                    <!-- <el-table-column align='center' prop="openid" label="Openid"></el-table-column> --> -->
                    <el-table-column align='center' prop="phone" label="手机"></el-table-column> -->
                    <!-- <el-table-column align='center' prop="balance" label="预存款余额">
                        <template slot-scope="scope">
                            <span
                                class="detialSpan"
                                @click="onBalanceDetial(scope.row,scope.$index)"
                            >{{scope.row.balance}}</span>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column align='center' prop="integral" label="积分">
                        <template slot-scope="scope">
                            <span
                                class="detialSpan"
                                @click="onIntegralDetial(scope.row,scope.$index)"
                            >{{scope.row.integral}}</span>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column align='center' prop="salesmanName" label="所属业务员"></el-table-column>
                    <el-table-column align='center' prop="audit" label="审核状态" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.audit ==0">未通过</span>
                            <span v-if="scope.row.audit ==1">通过</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column align='center' prop="status" label="启用状态" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status ==0">未启用</span>
                            <span v-if="scope.row.status ==1">启用</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column align='center' fixed="right" label="操作" width="240">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                @click="onCustomerDetail(scope.row)"
                            >查看</el-button>
                            <el-button
                                type="text"
                                size="small"
                                @click="onEditCustomer(scope.row)"
                            >编辑</el-button>
                             <el-button
                                type="text"
                                size="small"
                                @click="onCommission(scope.row)"
                            > 佣金 </el-button>
                              <el-button
                                type="text"
                                size="small"
                                @click="changeSubordinate(scope.row)"
                            > 修改所属上级 </el-button>
                                                          <el-button
                                type="text"
                                size="small"
                                @click="changeCommission(scope.row)"
                            > 调整佣金 </el-button>
                            <el-button
                                type="text"
                                size="small"
                                @click="onBalanceIntegral(scope.row)"
                            >调整积分/余额</el-button>

                             <el-button
                                type="text"
                                size="small"
                                @click="deleteCustomer(scope.row)"
                            >删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
        </div>
        <!--搜索列表分页-->
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync='currentPage'
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
        ></el-pagination>
        <!-- 高级检索弹框 -->
        <el-dialog
            title="高级检索"
            :visible.sync="dialogSearchForm2Visible"
            width="40%"
            class="advancedSearch"
            :close-on-click-modal="false"
        >
            <el-form :model="searchAllForm">
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="微信昵称" :label-width="labelwidth">
                            <el-input
                                v-model="searchAllForm.customerName"
                                clearable
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <!-- <el-col :span="12">
                        <el-form-item label="所属业务员" :label-width="labelwidth">
                            <el-input
                                v-model="searchAllForm.salesmanName"
                                clearable
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="审核状态" :label-width="labelwidth">
                            <el-select v-model="searchAllForm.audit" clearable placeholder="请选择审核状态">
                                <el-option label="已通过" :value="1"></el-option>
                                <el-option label="未通过" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="12">
                        <el-form-item label="启用状态" :label-width="labelwidth">
                            <el-select v-model="searchAllForm.status" clearable placeholder="请选择启用状态">
                                <el-option label="已启用" :value="1"></el-option>
                                <el-option label="未启用" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="注册时间" :label-width="labelwidth">
                            <el-date-picker
                                v-model="searchAllForm.regTime"
                                clearable
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择时间"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetSearchForm2">重置</el-button>
                <el-button type="primary" @click="onAllSearch">开始检索</el-button>
            </div>
        </el-dialog>
        <!-- 赠送优惠券弹框 -->
        <el-dialog
            title="赠送优惠券"
            :visible.sync="couponFormVisible"
            width="50%"
            :close-on-click-modal="false"
        >
            <div class v-loading="loading">
                <el-input placeholder="优惠券名称" v-model="couponForm.couponName" clearable>
                    <el-button type="primary" slot="append" icon="el-icon-search" @click="onCoupon"></el-button>
                </el-input>
                <el-table
                    ref="couponTable"
                    :data="tableData2"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="couponSelectionChange"
                    border
                >
                    <el-table-column align='center' type="selection" width="55"></el-table-column>
                    <el-table-column align='center' prop="couponName" label="优惠券名称"></el-table-column>
                    <el-table-column align='center' prop="abate" label="面额" width="120"></el-table-column>
                    <el-table-column align='center' prop="remainderCount" label="剩余张数"></el-table-column>
                    <el-table-column align='center' prop="reach" label="使用条件"></el-table-column>
                    <el-table-column align='center' prop="endTime" label="有效期"></el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetCouponForm">取 消</el-button>
                <el-button type="primary" @click="sendCouponForm">确 定</el-button>
            </div>
            <!--优惠劵列表分页-->
            <el-pagination
                class="pagination"
                @size-change="couponHandleSizeChange"
                @current-change="CouponHandleCurrentChange"
                :current-page.sync='currentPage_coupon'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="couponTotalCount"
            ></el-pagination>
        </el-dialog>
        <!-- 调整积分/余额弹框 -->
        <el-dialog
            title="修改余额或积分"
            :visible.sync="changeBalanceIntegralFormVisible"
            width="30%"
            :close-on-click-modal="false"
        >
            <el-form
                :model="changeBalanceIntegralForm"
                label-width="100px"
                class="changeBalanceIntegralForm"
            >
                <el-form-item label="调整余额">
                    <el-radio
                        v-model="balanceIntegralRadio.balance"
                        label="1"
                        @change="balanceIntegralChange"
                    >增加</el-radio>
                    <el-input
                        v-model="changeBalanceIntegralForm.addBalanceNum"
                        autocomplete="off"
                        placeholder="请输入大于0的正整数"
                        :disabled="balanceIntegralDisabled1"
                    >
                        <span slot="append">元</span>
                    </el-input>
                    <el-radio
                        v-model="balanceIntegralRadio.balance"
                        label="2"
                        @change="balanceIntegralChange"
                    >减少</el-radio>
                    <el-input
                        v-model="changeBalanceIntegralForm.reduceBalanceNum"
                        autocomplete="off"
                        placeholder="请输入大于0的正整数"
                        :disabled="balanceIntegralDisabled2"
                    >
                        <span slot="append">元</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="调整积分">
                    <el-radio
                        v-model="balanceIntegralRadio.integral"
                        @change="balanceIntegralChange"
                        label="1"
                    >增加</el-radio>
                    <el-input
                        v-model="changeBalanceIntegralForm.addIntegralNum"
                        autocomplete="off"
                        placeholder="请输入大于0的正整数"
                        :disabled="balanceIntegralDisabled3"
                    >
                        <span slot="append">分</span>
                    </el-input>
                    <el-radio
                        v-model="balanceIntegralRadio.integral"
                        @change="balanceIntegralChange"
                        label="2"
                    >减少</el-radio>
                    <el-input
                        v-model="changeBalanceIntegralForm.reduceIntegralNum "
                        autocomplete="off"
                        placeholder="请输入大于0的正整数"
                        :disabled="balanceIntegralDisabled4"
                    >
                        <span slot="append">分</span>
                    </el-input>
                </el-form-item>
                <el-form-item label='获取验证码'>
                    <el-input
                        value='136 8175 0322'
                        placeholder="请输入手机号" 
                        disabled="disabled"
                    >
                    <el-button @click='getCode' slot="append">{{codeText}}</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label='验证码'>
                    <el-input
                        v-model.trim="changeBalanceIntegralForm.code"
                        style='width: 335px;'
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="备注信息">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 6}"
                        v-model="changeBalanceIntegralForm.remark"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetChangeBalanceIntegralForm">取 消</el-button>
                <el-button type="primary" @click="sendBalanceIntegral">确 定</el-button>
            </div>
        </el-dialog>
         <!-- 修改所属上级弹框 -->
   
        <el-dialog
            title="修改所属上级弹框"
            :visible.sync="changeSubordinateFormVisible"
            width="50%"
            :close-on-click-modal="false"
        >
            <el-form
                :model="changeSubordinateForm"
                label-width="100px"
                class="changeBalanceIntegralForm"
            >
                <div class="khname"><span >客户名称:</span> <span>{{changeSubordinateForm.customerName}}</span> <span class="sssj">当前所属上级：</span> <span>{{changeSubordinateForm.salesmanName}}</span></div>
                 <!-- 搜索框 -->
               <div class v-loading="loading">
                <el-input placeholder="客户名称" v-model="subscribeForm.customerName" clearable>
                    <el-button type="primary" slot="append" icon="el-icon-search" @click="serachIt"></el-button>
                </el-input>
                <el-table
                    ref="couponTable"
                    :data="SubordinateTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="couponSelectionChange"
                    border
                >
                    <el-table-column align='center' type="selection" width="55"></el-table-column>
                    <el-table-column align='center' prop="customerName" label="客户名称"></el-table-column>
                    <el-table-column align='center' prop="parentName" label="联系人" width="120"></el-table-column>
                    <el-table-column align='center' prop="phone" label="联系手机"></el-table-column>
                    <el-table-column align='center' prop="levelName" label="分销等级"></el-table-column>
                     <el-table-column align='center' fixed="right" label="操作" width="240">
                        <template slot-scope="scope">
                               <el-button type="primary" id="btn"  
                               round @click="sendChangeSubordinate(scope.row)"
                               :disabled="scope.row.userID == changeSubordinateForm.parentUserID"
                               >设为上级</el-button>          
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                class="pagination"
                @size-change="SubordinateHandleSizeChange"
                @current-change="SubordinateHandleCurrentChange"
                :current-page.sync='currentPage_coupon'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="SubordinateTotalCount"
            ></el-pagination>
               
            </el-form>
            <!-- <div slot="footer" class="dialog-footer">
                <el-button @click="resetSubordinateForm">取 消</el-button>
                <el-button type="primary" @click="sendSubordinate">确 定</el-button>
            </div> -->
        </el-dialog>
       
          <!-- 调整佣金弹框 -->
        <el-dialog
            title="调整佣金"
            :visible.sync="changeCommissionFormVisible"
            width="30%"
            :close-on-click-modal="false"
        >
            <el-form
                :model="changeCommissionForm"
                label-width="100px"
                class="changeCommissionForm"
            >
                 <span>* 佣金余额：</span><span>￥{{changeCommissionForm.commission}}</span>
                <el-form-item label="佣金值">
                    <el-radio
                        v-model="balanceIntegralRadio.Commissionl"
                        label="1"
                        @change="balanceIntegralChange"
                    >增加</el-radio>
                    <el-input
                        v-model="changeCommissionForm.addBalanceNum"
                        autocomplete="off"
                        placeholder="请输入大于0的正整数"
                        :disabled="changeCommissionlDisabled1"
                    >
                        <span slot="append">元</span>
                    </el-input>
                    <el-radio
                        v-model="balanceIntegralRadio.Commissionl"
                        label="2"
                        @change="balanceIntegralChange"
                    >减少</el-radio>
                    <el-input
                        v-model="changeCommissionForm.reduceBalanceNum"
                        autocomplete="off"
                        placeholder="请输入大于0的正整数"
                        :disabled="changeCommissionlDisabled2"
                    >
                        <span slot="append">元</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="调整备注">
                    <el-input
                        type="input"
                        v-model="changeCommissionForm.remark"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetChangeCommissionForm">取 消</el-button>
                <el-button type="primary" @click="sendCommissionForm">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 审核订单弹框 -->
        <el-dialog
            title="审核订单"
            :visible.sync="examineFormVisible"
            width="25%"
            :close-on-click-modal="false"
        >
            <el-form :model="examineForm" label-width="100px">
                <el-form-item label='审核状态'>
                    <el-switch
                        v-model="examineForm.audit"
                        active-text="通过"
                        inactive-text="未通过"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 6, maxRows: 8}"
                        placeholder="备注内容不能超过100个字。"
                        v-model="examineForm.remark"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetExamineForm">取 消</el-button>
                <el-button type="primary" @click="sendExamineForm">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 分配业务员弹框 -->
        <el-dialog
            title="选择业务员"
            :visible.sync="customerSalesmanFormVisible"
            width="30%"
            :close-on-click-modal="false"
        >
            <div class v-loading="loading">
                <el-input placeholder="请输入业务员名字" v-model="searchForm.realName" clearable>
                    <el-button
                        type="primary"
                        slot="append"
                        icon="el-icon-search"
                        @click="searchCustomerSalesman"
                    ></el-button>
                </el-input>
                <el-table
                    ref="customerSalesmanTable"
                    :data="salesmanTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="salesmanSelectionChange"
                    border
                >
                    <el-table-column align='center' type="selection" width="55"></el-table-column>
                    <el-table-column align='center' prop="realName" label="业务员名称" width="120"></el-table-column>
                    <el-table-column align='center' prop="userName" label="账号" width="120"></el-table-column>
                    <el-table-column align='center' prop="phone" label="手机"></el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetCustomerSalesmanForm">取 消</el-button>
                <el-button type="primary" @click="sendCustomerSalesman">确 定</el-button>
            </div>
            <!--业务员列表分页-->
            <el-pagination
                class="pagination"
                @size-change="salesmanHandleSizeChange"
                @current-change="salesmanHandleCurrentChange"
                :current-page.sync='currentPage_salesman'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="customerSalesmanTotalCount"
            ></el-pagination>
        </el-dialog>
        <!-- 查看弹框 -->
        <el-dialog
            title="客户详情"
            :visible.sync="customerDetailsVisible"
            width="80%"
            :close-on-click-modal="false"
        >
            <div class="editCustomer" v-loading="loading">
                <div class="content">
                    <el-form
                        :inline="true"
                        ref="editCustomer"
                        :model="editCustomer"
                        label-width="120px"
                    >
                        <!-- <div class="editTitle">
                            <h2>公司信息</h2>
                        </div>
                        <el-row :gutter="5">
                            <el-col :span="6">
                                <el-form-item label="客户名称">
                                    <el-input
                                        v-model="editCustomer.customerName"
                                        :readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="客户编号">
                                    <el-input v-model="editCustomer.userID" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="所属业务员">
                                    <el-input
                                        v-model="editCustomer.salesmanName"
                                        :readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="所在地区">
                                    <el-input v-model="editCustomer.areaName" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="详细地址">
                                    <el-input v-model="editCustomer.address" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="邮编">
                                    <el-input v-model="editCustomer.postcode" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="传真">
                                    <el-input v-model="editCustomer.fax" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="电话">
                                    <el-input v-model="editCustomer.phone" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row> -->
                        <div class="editTitle">
                            <h2>联系人信息</h2>
                        </div>
                        <el-row :gutter="5">
                            <el-col :span="6">
                                <el-form-item label="联系人">
                                    <el-input v-model="editCustomer.linkman" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="微信">
                                    <el-input v-model="editCustomer.weiXin" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="手机">
                                    <el-input v-model="editCustomer.tel" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="邮箱">
                                    <el-input v-model="editCustomer.email" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="qq">
                                    <el-input v-model="editCustomer.qq" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="editTitle">
                            <h2>账号信息</h2>
                        </div>
                        <el-row>
                            <el-col>
                                <el-form-item label="账号">
                                    <el-input v-model="editCustomer.userName" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="账号状态" prop="status">
                                    <el-radio-group v-model="editCustomer.status">
                                        <el-radio disabled :label="0">未启用</el-radio>
                                        <el-radio disabled :label="1">启用</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <!-- <el-col>
                                <el-form-item label="审核状态">
                                    <el-radio-group v-model="editCustomer.audit">
                                        <el-radio disabled :label="0">未通过</el-radio>
                                        <el-radio disabled :label="1">通过</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col> -->
                        </el-row>
                        <!-- <div class="editTitle">
                            <h2>财务信息</h2>
                        </div>
                        <el-row :gutter="5">
                            <el-col :span="6">
                                <el-form-item label="开户名称">
                                    <el-input
                                        v-model="editCustomer.accountName"
                                        :readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="开户银行">
                                    <el-input
                                        v-model="editCustomer.depositBank"
                                        :readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="银行账号">
                                    <el-input
                                        v-model="editCustomer.accountNum"
                                        :readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="纳税人识别号">
                                    <el-input v-model="editCustomer.taxNo" :readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="发票抬头">
                                    <el-input
                                        v-model="editCustomer.invoiceName"
                                        :readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row> -->
                    </el-form>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="customerDetailsVisible=false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
             baseUrl: this.$store.state.apiUrl,
            loading: true,
            totalCount: 0,//总数据条数
            couponTotalCount: 0,
            customerSalesmanTotalCount: 0,
            maxResultCount: 10, //默认一页显示的个数,
            currentPage: 1,
            currentPage_salesman: 1,
            currentPage_coupon: 1,
            userId: '',
            searchForm: {//搜索表单
                customerName: '',
                audit: '',
                salesmanName: '',
                status: '',
                regTime: '',
                realName: '',
                userName: '',
                areaName: '',
                SkipCount: 0
            },
            searchAllForm: {//搜索表单
                customerName: '',
                audit: '',
                salesmanName: '',
                status: '',
                regTime: '',
                realName: '',
                userName: '',
                SkipCount: 0
            },
            dialogSearchForm2Visible: false,//搜索表单弹窗
            labelwidth: '90px',//label宽度
            searchListCtlForm: {//备用搜索列表控制键
                num: '',
                arrange: ''
            },
            changeBalanceIntegralFormVisible: false,//更改余额积分表单弹窗
            changeBalanceIntegralForm: {//更改余额积分表单
                addBalanceNum: '',
                reduceBalanceNum: '',
                addIntegralNum: '',
                reduceIntegralNum: '',
                remark: '',
                phone: '',
                code: ''
            },
            changeSubordinateFormVisible:false,
            changeCommissionFormVisible:false,
            changeSubordinateForm:{//所属上级
                customerName: '',
                userName:'',
                parentUserID:0
            },
           SubordinateTableData:[],
            subscribeForm:{
                customerName: '',
                userId:0,
                SkipCount: 0,
                
            },
            changeCommissionForm:{//调整佣金表单
                commission:'',
                addBalanceNum: '',
                reduceBalanceNum: '',
                remark: '',
            },

            examineFormVisible: false,//审核表单弹窗
            examineForm: {//审核表单
                audit: '',
                remark: ''
            },
            customerSalesmanFormVisible: false,//分配业务员表单弹窗
            salesmanTableData: [],//分配业务员表单数据
            salesmanSelection: [],//被选中的业务员
            customerSlelection: [],//被选中的客户
            couponSelection: [],//被选中的优惠券
            searchListTableData: [],//搜索列表数据
            couponFormVisible: false,//优惠券表单弹窗
            couponForm: {//优惠券表单
                couponName: ''
            },
            tableData2: [],//优惠券列表数据
            customerDetailsVisible: false,//客户详情弹窗
            editCustomer: {},//客户详情数据
            readonly: true,//只读属性
            balanceIntegralRadio: {//修改余额积分单选按钮控制
                balance: '1',
                integral: '1',
                Commissionl:'1'
            },
            balanceIntegralDisabled1: false,//修改余额积分输入控制
            balanceIntegralDisabled2: true,
            balanceIntegralDisabled3: false,
            balanceIntegralDisabled4: true,
            changeCommissionlDisabled1:false,
            changeCommissionlDisabled2:true,
            codeText: '获取验证码',
            remainSecond: 0,
            codeTimer: null
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
        });
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
           
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminCustomer/GetList",
                params: params,
                success(res) {
                    self.searchListTableData = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        // 获取验证码
        getCode() {
            let self = this
            // if(self.changeBalanceIntegralForm.phone.length != 11) {
            //     self.$message.error('请输入正确的手机号')
            //     return
            // }
            if(self.remainSecond > 1) {
                return
            }
            self.remainSecond = 61
            clearInterval(timer)
            let timer = setInterval(() => {
                if(self.remainSecond > 1) {
                    self.remainSecond -= 1
                    self.codeText = `重新获取(${self.remainSecond}s)`
                } else {
                    clearInterval(timer)
                    self.codeText = '重新获取'
                }   
            }, 1000)
            self.codeTimer = timer
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/SmsCode/SendSms",
                data: {
                    // phone: self.changeBalanceIntegralForm.phone
                    phone: 13681750322
                    // phone: 18820125063, // 测试
                },
                success(res) {
                    self.$message.success('发送成功')
                    // self.loading = false;
                },
                fail(res) {
                    // console.log(res);
                    // self.loading = false;
                }
            })
        },
        //搜索
        onSearch(params) {
            let self = this;
            let form = this.searchForm;
            //关闭弹窗 
            // this.dialogSearchForm2Visible = false;
            form.SkipCount = 0
            this.getDatas(form)
            this.currentPage = 1
        },
        onAllSearch() {
            // let self = this;
            let form = this.searchAllForm;
            //关闭弹窗 
            this.dialogSearchForm2Visible = false;
            form.SkipCount = 0
            this.getDatas(form)
            this.currentPage = 1
        },
        //查看客户详情
        onCustomerDetail(row) {
            let self = this;
            this.customerDetailsVisible = true;
            this.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminCustomer/GetInfo",
                params: { userId: row.userId },
                success(res) {
                    console.log(res);
                    self.editCustomer = res;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        //重置高级搜索
        resetSearchForm2() {
            this.searchAllForm.customerName = '';
            this.searchAllForm.audit = '';
            this.searchAllForm.salesmanName = '';
            this.searchAllForm.status = '';
            this.searchAllForm.regTime = ''
        },
        //重置关闭审核表单
        resetExamineForm() {
            this.examineForm.audit = '';
            this.examineForm.remark = '';
            this.examineFormVisible = false
        },
        //客户审核
        onExamineForm() {
            // 判断先选中客户
            if (this.customerSlelection.length == 0) {
                this.$message({
                    message: '请选择客户',
                    type: 'warning'
                });
            } else {
                this.examineFormVisible = true;
                if (this.customerSlelection.length == 1) {
                    this.examineForm.audit = this.customerSlelection[0].audit;
                }
            }
        },
        //提交客户审核
        sendExamineForm() {
            for (var i = 0; i < this.customerSlelection.length; i++) {
                if (!this.customerSlelection[i].salesmanName) {
                    this.$message({
                        message: '存在未分配业务员的用户',
                        type: 'warning'
                    });
                } else {
                    let self = this;
                    let userIds = [];
                    let audit = this.examineForm.audit;
                    let remark = this.examineForm.remark;
                    for (let i = 0; i < this.customerSlelection.length; i++) {
                        userIds.push(this.customerSlelection[i].userId);
                        console.log(userIds);
                    }
                    $http.POST({
                        url: this.$store.state.apiUrl + "/api/services/app/AdminCustomer/Aduit",
                        data: {
                            userIds: userIds,
                            audit: audit,
                            remark: remark
                        },
                        success(res) {
                            console.log(res);
                            self.$message({
                                message: res.data,
                                type: 'success'
                            });
                            //关闭弹框
                            self.examineFormVisible = false;
                            //从新加载页面数据
                            self.onSearch();
                        },
                        fail(res) {
                            console.log(res);
                            self.$message({
                                message: res.data,
                                type: 'error'
                            });
                        }
                    })
                }
            }

        },
        //重置销售员表单
        resetCustomerSalesmanForm() {
            this.$refs.customerSalesmanTable.clearSelection();
            this.customerSalesmanFormVisible = false;
        },
        //销售员
        onCustomerSalesmanForm() {
            let self = this;
            let params = this.searchForm;
            params.SkipCount = 0;
            // 判断先选中客户
            if (this.customerSlelection.length == 0) {
                this.$message({
                    message: '请选择客户',
                    type: 'warning'
                });
            } else {
                this.customerSalesmanFormVisible = true;
                this.loading = true;
                this.getCustomerSalesman(params);
            }
        },
        //加载销售员
        getCustomerSalesman(params) {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSalesman/GetList",
                params: params,
                success(res) {
                    self.salesmanTableData = res.items;
                    self.customerSalesmanTotalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //搜索业务员
        searchCustomerSalesman() {
            let params = this.searchForm;
            params.skipCount = 0;
            this.getCustomerSalesman(params);
            this.currentPage_salesman = 1
        },
        //提交分配销售员
        sendCustomerSalesman() {
            let self = this;
            let userIds = [];
            let salesmanId = this.salesmanSelection.userId;
            for (let i = 0; i < this.customerSlelection.length; i++) {
                userIds.push(this.customerSlelection[i].userId);
            }
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminCustomer/SetSalesman",
                data: {
                    salesmanId: salesmanId,
                    userIds: userIds
                },
                success(res) {
                    console.log(res);
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                    self.customerSalesmanFormVisible = false;
                    self.onSearch();
                },
                fail(res) {
                    console.log(res);
                    self.$message({
                        message: res.data,
                        type: 'error'
                    });
                }
            })
        },
        //客户列表选中
        customerSlelectionChange(val) {
            this.customerSlelection = val;
            console.log(this.customerSlelection);
        },
        //优惠券选中
        couponSelectionChange(val) {
            this.couponSelection = val;
            this.currentPage_coupon = 1
            console.log(this.couponSelection);
        },
        //分配业务员单选事件
        salesmanSelectionChange(val) {
            val.forEach((row, index) => {
                if (index === val.length - 1) return;
                this.$refs.customerSalesmanTable.toggleRowSelection(row, false);
            })
            this.salesmanSelection = val[0];
        },
        handleClick(row) {
            console.log(row);
        },
        //跳转用户修改页
        onEditCustomer(row) {
            console.log(row);
            this.$router.push({
                'path': '/editCustomer',
                'query': {
                    userId: row.userId
                }
            })
            // console.log(row);
        },
         //跳转佣金
        onCommission(row) {
            console.log(row);
            this.$router.push({
                'path': '/onCommission',
                'query': {
                   userId: row.userId,
                   userName:row.userName
                }
            })
            // console.log(row);
        },
        //跳转余额明细
        onBalanceDetial(row, index) {
            sessionStorage.setItem('moneyDetialForm', JSON.stringify(row));
            this.$router.push({
                'path': '/moneyDetial',
                'query': {
                    goodsId: 'balance',
                    userId: row.userId
                }
            })
        },
        // 跳转积分明细
        onIntegralDetial(row) {
            console.log(row);
            sessionStorage.setItem('moneyDetialForm', JSON.stringify(row));
            this.$router.push({
                'path': '/moneyDetial',
                'query': {
                    goodsId: 'integral',
                    userId: row.userId
                }
            })
        },
        //删除用户
        deleteCustomer(row) {
            this.$confirm('此操作将永久删除该客户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let self = this;
                $http.DELETE({
                    url: this.$store.state.apiUrl + "/api/services/app/AdminCustomer/DeleteCustomer",
                    params: { userId: row.userId },
                    success(res) {
                        console.log(res);
                        self.$message({
                            type: 'success',
                            message: res.data,
                        });
                        self.getDatas({
                            MaxResultCount: self.maxResultCount,
                        });
                        self.currentPage = 1
                    },
                    fail(res) {
                        console.log(res);
                        self.$message({
                            type: 'error',
                            message: res.message,
                        });
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //优惠券
        onCoupon() {
            // 判断先选中客户
            if (this.customerSlelection.length == 0) {
                this.$message({
                    message: '请选择客户',
                    type: 'warning'
                });
            } else {
                let params = this.couponForm;
                params.SkipCount = 0;
                //选中用户总数
                params.UserCount = this.customerSlelection.length;
                this.getCoupon(params);
            }
        },
        //加载优惠券数据
        getCoupon(params) {
            let self = this;
            this.couponFormVisible = true;
            this.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Coupon/GetUsableList",
                params: params,
                success(res) {
                    console.log(res);
                    self.tableData2 = res.items;
                    self.couponTotalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        //提交发放优惠券
        sendCouponForm() {
            let self = this;
            let couponIDs = [];
            let userIDs = [];
            for (let i = 0; i < this.customerSlelection.length; i++) {
                userIDs.push(this.customerSlelection[i].userId);
                console.log(userIDs);
            }
            for (let i = 0; i < this.couponSelection.length; i++) {
                couponIDs.push(this.couponSelection[i].couponID);
                console.log(couponIDs);
            }
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/Coupon/Send",
                data: {
                    "couponIDs": couponIDs,
                    "userIDs": userIDs
                },
                success(res) {
                    console.log(res);
                    self.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    self.couponFormVisible = false;
                },
                fail(res) {
                    console.log(res);
                }
            })
        },
        //重置优惠券选择
        resetCouponForm() {
            this.$refs.couponTable.clearSelection();
            this.couponFormVisible = false;
        },
        //打开调整积分/余额弹框
        onBalanceIntegral(row) {
            // if (this.customerSlelection.length != 1) {
            //     this.$message({
            //         message: '请选择一个客户',
            //         type: 'warning'
            //     });
            // } else {

            // }
            this.userId = row.userId;
            this.changeBalanceIntegralFormVisible = true;
        },
   
          //打开修改所属上级
        changeSubordinate(row) {
            let  self=this
            if(row.SkipCount == undefined){
                row.SkipCount = this.subscribeForm.SkipCount;
            }
            debugger;
            if(row.maxResultCount == undefined){
                row.maxResultCount = this.maxResultCount;
            }
            this.userId = row.userId;
            this.subscribeForm.userId = row.userId;
            this.changeSubordinateForm.customerName=row.userName
            this.changeSubordinateForm.salesmanName=row.parentUserName
            this.changeSubordinateForm.parentUserID=row.parentUserID 
            this.changeSubordinateFormVisible = true;
            this.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminCustomer/GetNoParentList",
                params: { 
                    userId: row.userId,
                    CustomerName:row.customerName,
                    SkipCount:row.SkipCount,
                    MaxResultCount:row.maxResultCount
                     },
                    // params:params,
                success(res) {
                     console.log(self.MaxResultCount,'lllls'),
                    self.SubordinateTableData = res.items;
                    self.SubordinateTotalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })

        },
        
        resetChangeSubordinate(){
            console.log('1')
            this.changeSubordinateFormVisible = false;
        },
        //设为上级
        sendChangeSubordinate(row){
            let self=this
            console.log(row,'sj')
            document.getElementById("btn").style.backgroundColor = 'red';
            // this.changeSubordinateFormVisible = false;
             $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminCustomer/ChangeSuperiorDto",
                data: {
                   parentId: row.userID,
                    userId: self.userId,
                  
                },
           
                success(res) {
                    // console.log(res);
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                   self.changeSubordinateFormVisible = false;
                    self.onSearch();
                },
                fail(res) {
                    console.log(res);
                }
            })
        },
        //修改上级佣金搜索
        serachIt(){
            debugger;
        let params = this.subscribeForm;
        params.userName = this.changeSubordinateForm.customerName;
        params.parentUserName = this.changeSubordinateForm.salesmanName;
        params.parentUserID = this.changeSubordinateForm.parentUserID;
       this.changeSubordinate(params)
                
        },
          //打开调整佣金
        changeCommission(row) {
            this.userId = row.userId;
             this.changeCommissionForm.commission=row.commission
            this.changeCommissionFormVisible = true;
        },
        //关闭调整佣金
        resetChangeCommissionForm(){
            this.changeCommissionFormVisible = false;
        },

         //提交调整佣金
        sendCommissionForm() {
            let self = this;
            let addBalanceNum = this.changeCommissionForm.addBalanceNum;
            let reduceBalanceNum = this.changeCommissionForm.reduceBalanceNum;
            let remark = this.changeCommissionForm.remark;
            let changebalance=0;
           
            if(this.balanceIntegralRadio.Commissionl ==1)  
            {
                changebalance=addBalanceNum;
            } else{
                changebalance= -reduceBalanceNum;
            }
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/Commission/UpdateAdjustmentCommission",
                data: {
                    commission: changebalance,
                    commissionRemark: remark,
                    userId: self.userId,
                  
                },
                success(res) {
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                   self.changeCommissionFormVisible = false;
                    self.onSearch();
                },
                fail(res) {
                    console.log(res);
                }
            })
        },
        
        //提交调整积分/余额
        sendBalanceIntegral() {
            let self = this;
            if(self.changeBalanceIntegralForm.code.length == 0) {
               self.$message.error('请输入验证码') 
            }
            // let userId = this.customerSlelection[0].userId;
            let addBalanceNum = parseInt(this.changeBalanceIntegralForm.addBalanceNum);
            let reduceBalanceNum = parseInt(this.changeBalanceIntegralForm.reduceBalanceNum);
            let addIntegralNum = parseInt(this.changeBalanceIntegralForm.addIntegralNum);
            let reduceIntegralNum = parseInt(this.changeBalanceIntegralForm.reduceIntegralNum);
            let remark = this.changeBalanceIntegralForm.remark;
            // for (let i = 0; i < this.customerSlelection.length; i++) {
            //     userIDs.push(this.customerSlelection[i].userId);
            //     console.log(userIDs);
            // }
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminUser/ModifyBalanceOrIntegral",
                data: {
                    addBalanceNum: addBalanceNum,
                    reduceBalanceNum: reduceBalanceNum,
                    addIntegralNum: addIntegralNum,
                    reduceIntegralNum: reduceIntegralNum,
                    remark: remark,
                    userId: self.userId,
                    // phone: self.changeBalanceIntegralForm.phone,
                    phone: 13681750322,
                    // phone: 18820125063, // 测试
                    code: self.changeBalanceIntegralForm.code
                },
                success(res) {
                    // console.log(res);
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                    self.resetChangeBalanceIntegralForm();
                    self.onSearch();
                },
                fail(res) {
                    console.log(res);
                }
            })
        },
        //重置调整积分/余额
        resetChangeBalanceIntegralForm() {
            this.changeBalanceIntegralForm.addBalanceNum = '';
            this.changeBalanceIntegralForm.reduceBalanceNum = '';
            this.changeBalanceIntegralForm.addIntegralNum = '';
            this.changeBalanceIntegralForm.reduceIntegralNum = '';
            this.changeBalanceIntegralForm.remark = '';
            this.changeBalanceIntegralFormVisible = false;
            this.balanceIntegralRadio.balance = '1';
            this.balanceIntegralRadio.integral = '1';
            this.balanceIntegralDisabled1 = false;
            this.balanceIntegralDisabled2 = true;
            this.balanceIntegralDisabled3 = false;
            this.balanceIntegralDisabled4 = true;
            this.changeBalanceIntegralForm.phone = '';
            this.changeBalanceIntegralForm.code = '';
            clearInterval(this.codeTimer)
            this.remainSecond = 0
            this.codeText = '获取验证码'
        },
        //调整积分/余额判断input启用
        balanceIntegralChange() {
            if (this.balanceIntegralRadio.balance == 1) {
                this.balanceIntegralDisabled1 = false;
                this.balanceIntegralDisabled2 = true;
            } else {
                this.balanceIntegralDisabled1 = true;
                this.balanceIntegralDisabled2 = false;
            }
            if (this.balanceIntegralRadio.integral == 1) {
                this.balanceIntegralDisabled3 = false;
                this.balanceIntegralDisabled4 = true;
            } else {
                this.balanceIntegralDisabled3 = true;
                this.balanceIntegralDisabled4 = false;
            }
             if (this.balanceIntegralRadio.Commissionl == 1) {
                this.changeCommissionlDisabled2 = true;
                this.changeCommissionlDisabled1 = false;
            } else {
                this.changeCommissionlDisabled2 = false;
                this.changeCommissionlDisabled1 = true;
            }
            
        },
        //搜索列表一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            this.getDatas(params);
        },
        //搜索列表跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.searchForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getDatas(params);
        },
        //优惠券一页显示多少个
        couponHandleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            params.UserCount = this.customerSlelection.length;
            this.getCoupon(params);
        },
        //优惠券跳转到指定页
        CouponHandleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.couponForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            params.UserCount = this.customerSlelection.length;
            this.getCoupon(params);
        },
        //业务员一页显示多少个
        salesmanHandleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            this.getCustomerSalesman(params);
        },
        //业务员跳转到指定页
        salesmanHandleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.couponForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            params.UserCount = this.customerSlelection.length;
            this.getCustomerSalesman(params);
        },
        //修改上级一页显示多少个
        SubordinateHandleSizeChange(val) {
            this.maxResultCount = val;
            let params = this.subscribeForm;
            params.maxResultCount = this.maxResultCount;
            params.UserCount = this.customerSlelection.length;
            params.userName = this.changeSubordinateForm.customerName;
            params.parentUserName = this.changeSubordinateForm.salesmanName;
            params.parentUserID = this.changeSubordinateForm.parentUserID;
            this.changeSubordinate(params)
        },
        //修改上级跳转到指定页
        SubordinateHandleCurrentChange(val) {
            debugger;
            this.loading = true;
            // this.maxResultCount = val;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.subscribeForm;
            params.maxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            params.UserCount = this.customerSlelection.length;
            params.userName = this.changeSubordinateForm.customerName;
            params.parentUserName = this.changeSubordinateForm.salesmanName;
            params.parentUserID = this.changeSubordinateForm.parentUserID;
            this.changeSubordinate(params)
        },
    }
}
</script>

<style lang='scss' scoped>
.customerPage {
    //搜索框
    .searchBox {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchTitle {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 10px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;
            i {
                width: 24px;
                height: 24px;
                background: url("../../assets/imgs/search01.png");
            }
        }
        .searchForm {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 20px;
            .el-form-item {
                margin-bottom: 0;
            }
        }
    }
    //搜索列表
    .searchList {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchListHead {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;
            .searchTitle {
                i {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/imgs/search02.png");
                }
            }
            .searchListCtl {
                button,
                .el-select {
                    width: 130px;
                    margin-left: 10px;
                }
            }
        }
        .searchListContent {
            .detialSpan {
                color: #ff9400;
                cursor: pointer;
            }
        }
    }
    //查看详情
    .editCustomer {
        .content {
            margin: 20px 50px;
            border: 1px solid #c5c5c5;
            .editTitle {
                display: flex;
                width: 100%;
                height: 40px;
                margin-bottom: 10px;
                align-items: center;
                border-bottom: 1px solid #c5c5c5;
                h2 {
                    padding-left: 20px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.customerPage {
    .el-dialog__header {
        background: #efefef;
        border-bottom: 1px solid #c5c5c5;
    }
    .advancedSearch {
        .el-input {
            width: 81%;
        }
        .el-select > .el-input {
            width: 101.5%;
        }
    }
}
.changeBalanceIntegralForm {
    .el-input-group {
        width: 80%;
    }
    .el-input--suffix{
    width: 35%;
    margin: 15px;
}
    .el-radio {
        margin-right: 20px;
    }
    .el-textarea {
        width: 96.5%;
    }
}
.khname{
    margin-bottom: 20px;
}
.sssj{
margin-left:50px;
}

</style>